import AddressInputImplementation from './implementation/AddressInputImplementation';
var AddressInputComponent = AddressInputImplementation;
export default AddressInputComponent;
//# sourceMappingURL=AddressInputComponent.js.map